export default __webpack_public_path__ + "2a3ed3d29b90c520585d036985f76405.svg";